/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { TipoPraticaRegolaPunteggioFasciaDTO } from './tipo-pratica-regola-punteggio-fascia-dto';


export interface PagedModelTipoPraticaRegolaPunteggioFasciaDTO { 
    content?: Array<TipoPraticaRegolaPunteggioFasciaDTO>;
    page?: PageMetadata;
}

